var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.disabled ? 'disabled' : 'enabled',on:{"click":function($event){return _vm.$emit('click-tile', _vm.tile)}}},[_c('TileImage',{attrs:{"tile":_vm.tile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }